/** Esclude worklog di sistema FORECAST dalle liste consuntive. */
export function isForecastWorklog(row) {
  return String(row?.activity_name || '').toUpperCase() === 'FORECAST';
}

export function excludeForecastWorklogs(rows) {
  return (rows || []).filter((row) => !isForecastWorklog(row));
}

export function excludeForecastActivities(activities) {
  return (activities || []).filter(
    (activity) => String(activity?.name || '').toUpperCase() !== 'FORECAST'
  );
}
